import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import * as React from 'react';

import { DimeButton } from '../DimeButton.js';

export type DimeMonthCalendarNavProps = Readonly<{
  title: string;
  onPrevious: () => void;
  onNext: () => void;
  onToday: () => void;
  todayDisabled?: boolean;
  status?: React.ReactNode;
}>;

export function DimeMonthCalendarNav({
  title,
  onPrevious,
  onNext,
  onToday,
  todayDisabled = false,
  status,
}: DimeMonthCalendarNavProps) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <div className="flex items-center gap-1">
        <DimeButton
          variant="outline"
          size="icon-sm"
          aria-label="Previous month"
          onClick={onPrevious}
        >
          <ChevronLeftIcon />
        </DimeButton>
        <DimeButton variant="outline" size="icon-sm" aria-label="Next month" onClick={onNext}>
          <ChevronRightIcon />
        </DimeButton>
        <DimeButton variant="outline" size="sm" disabled={todayDisabled} onClick={onToday}>
          Today
        </DimeButton>
      </div>
      <h2 className="text-lg font-semibold">{title}</h2>
      <div role="status" className="text-sm text-muted-foreground">
        {status}
      </div>
    </div>
  );
}
